import { render, staticRenderFns } from "./price-warnings.vue?vue&type=template&id=6bd927f2&scoped=true"
import script from "./price-warnings.vue?vue&type=script&lang=js"
export * from "./price-warnings.vue?vue&type=script&lang=js"
import style0 from "./price-warnings.vue?vue&type=style&index=0&id=6bd927f2&prod&scoped=true&lang=scss"
import style1 from "./price-warnings.vue?vue&type=style&index=1&id=6bd927f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd927f2",
  null
  
)

export default component.exports